var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongWangluoyichangXian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tongyong_wangluoyichang_xian_svg__clip0_5239_55345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.333a.833.833 0 100-1.666.833.833 0 000 1.666z",
    fill: "#3F465C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2.5L3 13.333",
    stroke: "#3F465C",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.317 10.2a3.148 3.148 0 011.935.908.5.5 0 10.707-.707A4.145 4.145 0 009.18 9.35l-.863.85zM9.75 7.384a6.194 6.194 0 00-6.104 1.57.5.5 0 01-.707-.707 7.194 7.194 0 017.61-1.65l-.8.787zm1.022.398a6.192 6.192 0 011.633 1.172.5.5 0 10.708-.707 7.192 7.192 0 00-1.593-1.202l-.748.737zm2.182-2.15c.554.355 1.07.77 1.537 1.237a.5.5 0 10.707-.707 10.143 10.143 0 00-1.515-1.247l-.729.718zm-.156-1.249A10.139 10.139 0 00.854 6.162a.5.5 0 00.707.707 9.142 9.142 0 0110.486-1.746l.75-.74zm-4.88 4.805l-1.41 1.389a3.147 3.147 0 00-.707.531.5.5 0 11-.707-.707 4.147 4.147 0 012.824-1.213z",
    fill: "#3F465C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tongyong_wangluoyichang_xian_svg__clip0_5239_55345"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/tongyong_wangluoyichang_xian.377ba4d0.svg";
export { SvgTongyongWangluoyichangXian as ReactComponent };